export default __webpack_public_path__ + "static/media/delivery-truck.2ab43d56.svg";